// Swiffy slider override

// Base function is taken from swiffy slider and our hidden element logic is added to override that

swiffyslider.slideToByIndicator = function () {
    const indicator = window.event.target;
    const indicatorIndex = Array.from(indicator.parentElement.children).indexOf(
      indicator
    );
    const indicatorCount = indicator.parentElement.children.length;
    const sliderElement = indicator.closest(".swiffy-slider");
    const children = sliderElement.querySelector(".slider-container").children;
    const chidrenList = [];

    // This loop checks the items that are hidden in the loop and capture those
    for (let i = 0; i < children.length; i++) {
      if (
        !children[i].classList.contains("hidden") &&
        !children[i].classList.contains("hide-3d")
      ) {
        chidrenList.push(children[i]);
      }
    }

    // counter the relative slides and set indicator count on base of thirdParty, also update the slider dots as per those
    const slideCount = chidrenList.length;
    const relativeSlideIndex = (slideCount / indicatorCount) * indicatorIndex;
    this.slideTo(sliderElement, relativeSlideIndex);
  };

  swiffyslider.slideTo = function (sliderElement, slideIndex) {
    const container = sliderElement.querySelector(".slider-container");
    const gapWidth = parseInt(window.getComputedStyle(container).columnGap);
    let offset = 0;
    for (let i = 0; i < container.children.length; i++) {
      if (
        !container.children[i].classList.contains("hidden") &&
        !container.children[i].classList.contains("hide-3d")
      ) {
        offset = container.children[i].offsetWidth;
        break;
      }
    }
    const scrollStep = container.children[0].offsetWidth
      ? container.children[0].offsetWidth + gapWidth
      : offset + gapWidth;
    const nodelay = sliderElement.classList.contains("slider-nav-nodelay");
    container.scroll({
      left: scrollStep * slideIndex,
      behavior: nodelay ? "auto" : "smooth",
    });
  };
